<template>
  <v-container my-1 py-1 px-0>
    <v-layout>
      <v-flex>
        <v-card>
          <v-layout row wrap>
            <v-flex ml-4 mr-1 xs12 sm4 md3>
              <v-select v-model="dateFieldSelected" :items="dateFields" item-value="field" item-text="description" label="Campo Fecha" return-object></v-select>
            </v-flex>
            <v-flex ml-1 mr-1 xs12 sm8 md6>
              <hzd-date-range-picker v-model="dateRange" :max="max"></hzd-date-range-picker>
            </v-flex>
            <v-layout align-center justify-end row wrap>
            <v-btn small color="secondary" @click="emmitFilters">aplicar filtro</v-btn>
          </v-layout>
          </v-layout>
          
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import hzdDateRangePicker from "./DateRangePicker";

export default {
  data() {
    return {
      dateRange: {
        fromDate: this.$moment()
          .subtract(7, "d")
          .format("YYYY-MM-DD"),
        toDate: this.$moment().format("YYYY-MM-DD")
      },
      max: this.$moment().format("YYYY-MM-DD"),
      dateFieldSelected: {
        field: "created_at",
        description: "Fecha de Creacion"
      },
      dateFields: [
        {
          field: "created_at",
          description: "Fecha de Creacion"
        }
        // ,{
        //   field: "modified_at",
        //   description: "Fecha de Modificacion"
        // }
      ]
    };
  },
  components: {
    hzdDateRangePicker
  },
  methods: {
    emmitFilters() {
      this.$emit("input", {
        fromDate: this.dateRange.fromDate,
        toDate: this.dateRange.toDate,
        field: this.dateFieldSelected.field
      });
    }
  },
  created() {
    this.emmitFilters();
  }
};
</script>
